export default __webpack_public_path__ + "static/media/l.245bc8a3.svg";